import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UserPage from './UserPage';
import DetailPage from './DetailPage';
import AdminPage from './AdminPage';
import SavedPage from './SavedPage';
import AboutPage from './AboutPage'; // Import file baru
import ContactPage from './ContactPage';
import PrivacyPage from './PrivacyPage';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <Router>
      <HelmetProvider>
      <Routes>
        <Route path="/" element={<UserPage />} />
        <Route path="/ide/:slug" element={<DetailPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/saved" element={<SavedPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
      </HelmetProvider>
    </Router>
  );
}

export default App;